import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/chat/page.tsx");
